export default class Cards {
  constructor() {
    this.planCards = document.querySelectorAll('.marketplace-plan-card');
    this.submitButton = document.querySelector('#change-plan-btn');
    this.selectedPlan = null;
    const subscriptionCard = document.querySelectorAll('.js-card-subscription');

    // Plan Cards
    // This sets the card as active when clicked on it
    if (this.planCards) {
      this.planCards.forEach(planCard => {
        planCard.addEventListener('click', this.setActive.bind(this));
      });
    }
    if (this.submitButton) {
      this.submitButton.addEventListener('click', this.choosePlan.bind(this));
    }

    // Subscription Cards
    if (subscriptionCard.length) {
      this.subscriptionCard = subscriptionCard;
      this.subscriptionCards();
    }
  }

  choosePlan() {
    const url = this.submitButton.dataset.url;
    this.submitButton.disabled = true;
    this.submitButton.classList.add('disabled');
    $.ajax({
      url: url.replace('_plan_selected_', this.selectedPlan),
      type: 'post',
      dataType: 'json',
      success: function(response) {
        window.top.location.href = response.response_path
      }
    });
  }

  setActive(e) {
    this.planCards.forEach(function(plan) {
      plan.classList.remove('box-selection-active');
    });
    const elem = e.currentTarget;
    const selectedPlanName = elem.dataset.plan;
    const currentPlanName = elem.dataset.current;
    if (selectedPlanName !== currentPlanName) {
      this.selectedPlan = selectedPlanName
      this.submitButton.disabled = false;
      this.submitButton.classList.remove('disabled');
    } else {
      this.selectedPlan = null;
      this.submitButton.disabled = true;
      this.submitButton.classList.add('disabled');
    }
    elem.classList.add('box-selection-active');
  }

  subscriptionCards() {
    const subscriptions = document.querySelectorAll('.js-card-subscription');
    if (subscriptions) {
      subscriptions.forEach(item => {
        item.addEventListener('click', (e) => {
          const deleteAction = e.target.closest('.subscription-action');
          if (deleteAction) return;

          // Repeat payment
          const url = item.getAttribute('data-url');
          if (!url) return;

          if (item.classList.contains('js-payment-failed')) {
            top.loadAction(url, 'Repeat Payment', '', 'update', 'mini');
          } else {
            window.location = url;
          }
        })
      });
    }
  }
}
